export const enemVip = {
	clientUrl: window.location.origin,
	apiUrl: process.env.REACT_APP_API_URL
}

export const simuladoUrl = {
	clientUrl: process.env.REACT_APP_SIMULADO_CLIENT_URL,
	apiUrl: process.env.REACT_APP_SIMULADO_API_URL
}
